import { type FC, type ReactNode } from 'react';
import { TextSmall } from '@components/Typography/Typography';
import cn from 'classnames';

import { Container } from '../Container/container';

interface NotificationProps {
  text: string;
  className?: string;
  icon?: () => ReactNode | null;
}

const Notification: FC<NotificationProps> = ({ icon, text, className }) => {
  return (
    <Container
      variant="notification"
      className={cn(
        'flex items-center gap-2 h-[3.5rem] w-full px-2',
        className,
      )}
    >
      {icon && icon()}
      <TextSmall weight="medium" className="!text-main-bg leading-1.2">
        {text}
      </TextSmall>
    </Container>
  );
};

export { Notification };
